import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a circle with x-mark icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/circle-xmark?f=classic&s=solid
 */
export const CircleXmarkSolidIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faCircleXmark} {...props} />;
};
